import styled from '@emotion/styled';
import DaumPostcodeEmbed from 'react-daum-postcode';

interface AddressModalProps {
  isOpen: boolean;
  onClose: () => void;
  onComplete: (address: string) => void;
}

const AddressModal = ({ isOpen, onClose, onComplete }: AddressModalProps) => {
  if (!isOpen) return null;

  const handleComplete = (data: any) => {
    let fullAddress = data.address;
    let extraAddress = '';

    // 도로명 주소인 경우 참고항목 추가
    if (data.addressType === 'R') {
      // 법정동명이 있을 경우
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      // 건물명이 있을 경우
      if (data.buildingName !== '') {
        extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
      }
      // 참고항목이 있을 경우 괄호로 추가
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
    }

    // 우편번호도 필요하면 : data.zonecode
    onComplete(fullAddress);
    onClose();
  };

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>주소 검색</ModalTitle>
          <CloseButton onClick={onClose}>x</CloseButton>
        </ModalHeader>
        <PostcodeWrapper>
          <DaumPostcodeEmbed onComplete={handleComplete} style={{ height: '450px' }} autoClose={false} />
        </PostcodeWrapper>
      </ModalContent>
    </ModalOverlay>
  );
};

export default AddressModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  max-height: 600px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
`;

const ModalHeader = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
`;

const ModalTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background: #e9ecef;
    color: #333;
  }
`;

const PostcodeWrapper = styled.div`
  width: 100%;
  height: 450px;
`;
